import type { GebiedLabel } from '@models/GebiedLabel'

export { groupLabelsByGebied }

const groupLabelsByGebied = (labels: GebiedLabel[]) => {
  const grouped = labels.reduce(
    (acc, label) => {
      const key = label.gebiedscode

      return {
        ...acc,
        [key]: [...(acc[key] || []), label],
      }
    },
    {} as Record<string, GebiedLabel[]>,
  )

  return Object.values(grouped)
    .map((gebiedLabels) =>
      [...gebiedLabels].sort((a, b) => a.label.localeCompare(b.label)),
    )
    .sort((a, b) => a[0].gebiedscodeLabel.localeCompare(b[0].gebiedscodeLabel))
}
